import { render, staticRenderFns } from "./CabinetList.vue?vue&type=template&id=e877407c&scoped=true&"
import script from "./CabinetList.vue?vue&type=script&lang=js&"
export * from "./CabinetList.vue?vue&type=script&lang=js&"
import style0 from "./CabinetList.vue?vue&type=style&index=0&id=e877407c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e877407c",
  null
  
)

export default component.exports